import React, { useState } from 'react'
import Logo from '/static/logo_footer.svg'
import SbEditable from 'storyblok-react'
import Link from 'gatsby-link'
import resolveLink from '@/utils/resolveLink'
import FooterSection from '@/components/Footer/FooterSection'

interface Props {
  blok: StoryblokComponent & {
    title: Record<string, string>
    content: string
    action_url: string
    action_cta_text: string
    marginTop?: number
    marginBottom?: number
  }
}

export const FooterBlock = ({ blok }: Props) => {
  const navData = blok.content.footer_navigation.map(item => {
    return {
      ...item,
      open: false,
    }
  })

  const [data, setData] = useState(navData)

  const handleClick = _uid => {
    setData(data =>
      data.map(item => {
        return {
          ...item,
          open: _uid === item._uid ? !item.open : false,
        }
      }),
    )
  }

  return (
    <SbEditable content={blok} key={blok._uid}>
      <footer className="bg-darkblue" aria-labelledby="footer">
        <div
          className={`mx-auto max-w-7xl ${type === 'orphan' ? 'py-12 px-6 lg:py-16' : 'py-12 px-6 lg:py-28'}  2xl:max-w-screen-2xl`}
        >
          <div
            className={`${type === 'orphan' ? '' : 'mb-12 lg:mb-20'}  flex flex-row items-center `}
          >
            <Link to={resolveLink('/')}>
              <img className="h-11" src={Logo} alt="Cloud Gateway Logo" />
            </Link>
          </div>
          <div className="flex flex-col justify-between gap-y-8 lg:flex-row">
            <div className="flex lg:order-last lg:items-center lg:justify-center">
              <div className="grid w-full grid-cols-1 gap-4 text-white sm:grid-cols-4 md:grid-cols-4 md:gap-8 lg:grid-cols-5 ">
                {data.map((item, index) => (
                  <div className="w-full lg:w-auto" key={index}>
                    <FooterSection {...item} onClick={handleClick} />
                  </div>
                ))}
                <div className="mt-6 flex flex-row space-x-3 self-start lg:mt-0">
                  {blok.accreditations.map(img => (
                    <img
                      src={img?.filename}
                      alt={img?.alt}
                      className="max-w-[53px]"
                    />
                  ))}
                </div>
              </div>
            </div>
            {(settings.telephone_number || settings.email) && (
              <div className="mr-8 space-y-8 xl:col-span-1">
                <div className="flex flex-col">
                  <div className="text-brightgreen font-display mb-3 lg:mb-7">
                    Contact
                  </div>
                  <a
                    href={`tel:${settings.telephone_number}`}
                    className="hover:text-brightgreen py-0.5 text-sm text-white duration-300 tracking-[-0.02em]"
                  >
                    <span className="text-white">T:</span>{' '}
                    {settings.telephone_number}
                  </a>
                  <a
                    href={`mailto:${settings.email}`}
                    className="hover:text-brightgreen py-0.5 text-sm text-white duration-300 tracking-[-0.02em]"
                  >
                    <span className="text-white">E:</span> {settings.email}
                  </a>
                  <div className="mt-12 space-x-3">
                    <a
                      className="hover:text-brightgreen text-white transition duration-300"
                      href="https://twitter.com/cloudgatewayltd"
                      target="_blank"
                    >
                      <i class="fab fa-twitter fa-lg"></i>
                    </a>
                    <a
                      className="hover:text-brightgreen text-white transition duration-300"
                      href="https://www.linkedin.com/company/cloudgateway/"
                      target="_blank"
                    >
                      <i class="fab fa-linkedin-in fa-lg"></i>
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="py-5">
          <div className="mx-auto flex max-w-7xl flex-col px-6 lg:flex-row lg:items-center lg:justify-between 2xl:max-w-screen-2xl">
            <p className="mb-1 text-xs text-white lg:mb-0">
              © Cloud Gateway {new Date().getFullYear()}. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </SbEditable>
  )
}

FooterBlock.displayName = 'FooterBlock'
